import { firebaseAction, vuexfireMutations } from 'vuexfire'
import firebaseApp from '../../firebase-app'

export default {
  namespaced: true,
  state: {
    userId: null,
    accountId: null,
    items: []
  },
  getters: {
    accounts ({ accountId, items }) {
      return accountId ? items.filter(({ '.key': id }) => id !== accountId) : []
    }
  },
  mutations: {
    ...vuexfireMutations,

    SET_USER (state, { userId, accountId }) {
      state.userId = userId
      state.accountId = accountId
    }
  },
  actions: {
    init: firebaseAction(async ({ bindFirebaseRef, unbindFirebaseRef, commit }, { userId, accountId }) => {
      commit('SET_USER', { userId, accountId })
      if (userId) {
        await bindFirebaseRef('items', firebaseApp.database().ref(`users/${userId}/accounts`))
      } else {
        unbindFirebaseRef('items')
      }
    }),
    destroy: firebaseAction(({ unbindFirebaseRef }) => {
      unbindFirebaseRef('items')
    }),
    async setAccount ({ state: { userId }, commit }, accountId) {
      if (userId) {
        const accountFn = firebaseApp.functions().httpsCallable('user-account')
        await accountFn({
          accountId
        })
        commit('SET_USER', { userId, accountId })
      }
    }
  }
}
